import ACTION_NAMES from 'actions/ACTION_NAMES';
import { generateReadActionCreator, generateCreateActionCreator, generateDeleteActionCreator } from 'actions/crudActionCreators';
import routes from 'actions/routes';

export default {
    addFavorites: generateCreateActionCreator(routes.API_FAVORITES, ACTION_NAMES.FAVORITES),
    readFavorites: generateReadActionCreator(routes.API_FAVORITES, ACTION_NAMES.FAVORITES),
    readFavoritesWithDisplayName: generateReadActionCreator(routes.API_FAVORITES, ACTION_NAMES.FAVORITES_WITH_DISPLAY_NAME),
    deleteFavorite: generateDeleteActionCreator(routes.API_FAVORITES, ACTION_NAMES.FAVORITES)
}
